import { productAPI } from './api';

export interface Product {
  id: string;
  name: string;
  description?: string;
  price: number;
  stock?: number;
  category?: string;
  unit?: string;
}

export const searchProducts = async (query: string): Promise<Product[]> => {
  const response = await productAPI.get('/products/search', {
    params: { q: query }
  });
  return response.data.products || [];
};

export const getAllProducts = async () => {
  const response = await productAPI.get('/products');
  return response.data;
};

export default productAPI;

